import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=4c809cc6&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"
import style0 from "./Inquiry.vue?vue&type=style&index=0&id=4c809cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c809cc6",
  null
  
)

export default component.exports